import React, { memo, forwardRef, useImperativeHandle, useState, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import Modal from "@mui/material/Modal";
import { useFormik } from "formik";
import PropTypes from "prop-types";

import api from "services/api";
import { promptAlertMessage } from "store/slices/alert";
import serveRequestErrors from "common/serve-request-errors";
import AppInput from "components/app-input";
import AppButton from "components/app-button";

export const AppCancelOvertimeModal = (props, ref) => {
	const dispatch = useDispatch();
	const [overtimeId, setOvertimeId] = useState(null);
	const [visible, setVisible] = useState(false);
	const initialValues = useMemo(() => ({ remark: "" }), []);
	const formik = useFormik({
		initialValues,
		onSubmit: (values) => {
			onHandleConfirm(values);
		},
	});

	const onHandleDismiss = useCallback(() => {
		setVisible(false);
	}, []);

	//prettier-ignore
	const onHandleShow = useCallback((id) => {
		setOvertimeId(id);
		formik.resetForm();
		setVisible(true);
	}, [formik]);

	//prettier-ignore
	const onHandleConfirm = useCallback(async (values) => {
		let response = null;

		try {
			await api.post.overtime.cancel({ id: overtimeId, remark: values.remark });
			response = true;
		} catch (error) {
			serveRequestErrors(error);
		} finally {
			formik.setSubmitting(false);
		}

		if (response) {
			onHandleDismiss();
			dispatch(promptAlertMessage({ message: "Overtime has been cancelled successfully" }));
			props.onHandleGetList();
		}
	}, [dispatch, overtimeId, formik, onHandleDismiss, props]);

	//prettier-ignore
	useImperativeHandle(ref, () => ({
		onHandleShow: onHandleShow,
		onHandleDismiss: onHandleDismiss,
	}));

	return (
		<Modal classes={{ root: "app-cancel-overtime-modal" }} open={visible} onClose={onHandleDismiss} aria-labelledby="cancel-overtime-modal" aria-describedby="cancel-overtime-modal">
			<div className="cancel-overtime-modal">
				<div className="cancel-overtime-modal__main">
					<div className="cancel-overtime-modal__header">
						<p className="cancel-overtime-modal__title">Cancel Overtime</p>
					</div>

					<form className="cancel-overtime-modal__body" onSubmit={formik.handleSubmit}>
						<p className="cancel-overtime-modal__description">Are you sure want to cancel this overtime request?</p>

						{/* prettier-ignore */}
						<AppInput multiline multilineRow={4} maxLength={255} type="text" name="remark" label="Remark" placeholder="Enter remark" value={formik.values.remark} error={formik.errors.remark} touched={formik.touched.remark} disabled={formik.isSubmitting} onChange={formik.handleChange} />

						<div className="cancel-overtime-modal__button-container">
							<AppButton type="button" label="Cancel" outline onClick={onHandleDismiss} />
							<AppButton type="submit" label="Confirm" disabled={formik.isSubmitting} />
						</div>
					</form>
				</div>
			</div>
		</Modal>
	);
};

export default memo(forwardRef(AppCancelOvertimeModal));

AppCancelOvertimeModal.propTypes = {
	ref: PropTypes.object,
	onHandleGetList: PropTypes.func,
};
